import React from 'react';

export function EmptyBlogs({ search }) {
  return (
    <div className="text-center">We didn't find anything for "{search}".</div>
  );
}
